import React, { Component } from "react";
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Form,
    Label,
    Input,
    Button,
} from "reactstrap";
import config from "../../config/config";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import withRouter from "../../components/Common/withRouter";

class CreateTourInclusion extends Component {
    constructor(props) {
        super(props);
        this.state = {
            breadcrumbItems: [
                { title: "Tour Inclusion", link: "/tourinclusions" },
                { title: "Create Tour Inclusion", link: "#" },
            ],
            tourInclusionName: "",
        };
    }


    handleInputChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    };

    handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch(`${config.API_BASE_URL}/tourinclusions`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    tourinclusion_name: this.state.tourInclusionName,
                }),
            });

            const data = await response.json();

            if (response.ok) {
                console.log("Tour inclusions created:", data);
                this.props.router.navigate("/tourinclusions");
            } else {
                console.error("Failed to create tour inclusions:", data);
                alert(data.message || "Failed to create tour inclusions");
            }
        } catch (error) {
            console.error("Error:", error);
            alert("Error creating tour inclusions");
        }
    };

    handleCancel = () => {
        this.props.router.navigate("/tourinclusions");
    };

    render() {
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs
                            title="Create Tour Inclusion"
                            breadcrumbItems={this.state.breadcrumbItems}
                        />
                        <Row>
                            <Col lg={12}>
                                <Card>
                                    <CardBody>
                                        <Form onSubmit={this.handleSubmit}>
                                            <Row>
                                                <Col md={12}>
                                                    <div className="mb-3">
                                                        <Label className="form-label">Tour Inclusion Name</Label>
                                                        <Input
                                                            type="text"
                                                            name="tourInclusionName"
                                                            placeholder="Enter tour inclusion name"
                                                            value={this.state.tourInclusionName}
                                                            onChange={this.handleInputChange}
                                                            required
                                                        />
                                                    </div>
                                                </Col>
                                            </Row>

                                            <Row className="mt-4">
                                                <Col className="d-flex justify-content-end">
                                                    <Button type="submit" color="primary" className="me-2">
                                                        Create Tour Inclusion
                                                    </Button>
                                                    <Button
                                                        type="button"
                                                        color="secondary"
                                                        onClick={this.handleCancel}
                                                    >
                                                        Cancel
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}

export default withRouter(CreateTourInclusion);